import { cr } from "fire-wind-water";

function ObserverProxy<T extends new (...args: any[]) => Record<string, any>>(
  constructor: T
) {
  return class extends constructor {
    $$directive: any;

    observer(): void {
      this.observerEach(this, (k, d) => {
        this.addObserver(k, d);
      });
    }

    addObserver(key, value): void {
      if (!this.$$directive[key]) {
        this.$$directive[key] = [];
      }
      this.observerBind(key, value);
      cr.each(this.$$directive[key], (d) => {
        d.update();
      });
    }

    resetObserver(key, value, root): void {
      this.defineReactive(value, key, this.$$directive[root]);
      cr.each(this.$$directive[root], (d) => {
        d.update();
      });
    }

    detectChanges(): void {
      cr.each(this.$$directive, (o) => {
        cr.each(o, (d) => {
          d.update();
        });
      });
    }

    observerBind(key, value): void {
      if (cr.isPlainObject(value)) {
        this.defineReactiveObject(value, this.$$directive[key]);
      } else {
        this.defineReactive(this, key, this.$$directive[key]);
      }
    }

    observerEach(target, cn): void {
      cr.each(target, (d, k) => {
        if (cr.isFunction(d) || /^\$/.test(k)) {
          return;
        }
        cn(k, d);
      });
    }

    defineReactiveObject(value: any, update: any[]): void {
      cr.each(value, (d, k) => {
        if (cr.isPlainObject(d)) {
          this.defineReactiveObject(d, update);
        } else {
          this.defineReactive(value, k, update);
        }
      });
    }

    defineReactive(target, key, update): void {
      let Val = target[key];
      Object.defineProperty(target, key, {
        get() {
          return Val;
        },
        set(newVal: any) {
          Val = newVal;
          cr.each(update, (d) => {
            d.update(newVal, key);
          });
        },
      });
    }
  };
}

export { ObserverProxy };
